import wp from "@/api/wp";

const all = async ({ commit }) => {
  let list = await wp
    .posts()
    .page(1)
    .perPage(8)
    .embed();

  commit("setList", list);
};

const find = async ({ commit }, { slug } = {}) => {
  let [item] = await wp
    .posts()
    .slug(slug)
    .embed();

  commit("setItem", item);
};

const rewind = ({ commit }) => {
  commit("rewind");
};

const loadMore = ({ commit }) => {
  commit("setLoaded", false);
};

const next = async ({ commit, state }) => {
  commit("incrementCurrent");

  if (!state.loaded) {
    let list = await wp
      .posts()
      .page(state.current)
      .perPage(8)
      .embed();

    commit("setTotal", list._paging.totalPages);
    commit("appendList", list);
    commit("setLoaded", true);
  }
};

export default {
  all,
  find,
  next,
  rewind,
  loadMore
};
